export default __webpack_public_path__ + "static/metatokyo-88fac14980663360285b23ce3cd564a8.png";